<template>
    <div v-loading="isLoading">
        <div id="vegaView"></div>

        <div id="tip-vega" class="vg-tooltip" hidden="true"></div>
    </div>
</template>

<script>

import apiAxios from "@/config/apiAxios";

import * as vega from 'vega'

export default {
    name: 'bubbleChart',
    components: { },
    data() {
        return {
            userId: sessionStorage.getItem( 'USER_ID' ),
            isLoading: false,
            toolBoxList: []

        }
    },
    methods: {
      //查询工具箱列表
        getTableDatas(){
            
            this.isLoading = true;
            let params = {
                "userId": this.userId,
                "tags": ["tech_sbom"],
                "filter": "'fileInfo.extends.resource.delStatus' eq 1  and 'fileInfo.extends.resource.type' eq '1'"
            }
            //查询表格数据
            // apiAxios.apmSyncPost( 'virtual_tool_box_list_00001', params, {}, _res => { //虚拟用户，执行和获取ui配置有问题
            apiAxios.apmSyncPost( 'tool_box_list_00001', params, {}, _res => {
                if(_res.code == 200 ){
                    let data = _res.data.data || [];
                    if(data.length <= 0){
                        this.isLoading = false;
                        return ;
                    }
                    this.toolBoxList = data;
                    this.vegaInit();
                    this.isLoading = false;
                }else{
                    this.$message.error(_res.msg);
                    this.isLoading = false;
                }
            });
        },
      vegaInit(){
        let vegaData = [];

        this.toolBoxList.forEach(item => {
          item.category = item.name;
          item.tags = item.tags || {};
          if(item.tags["tech_dev"]){
              item.amount = 0.6;
          }else{
              item.amount = 0.8;
          }
          // if(item.tags["scene_cmdinfo"]){
          //     vegaData.push(item);
          // }
          vegaData.push(item);
          
        });

        var vegaConfig = {
            "$schema": "https://vega.github.io/schema/vega/v5.json",
            "width": window.innerWidth - 40,//600,
            "height": window.innerHeight - 40,//300,
            "padding": {"left": 5, "right": 5, "top": 20, "bottom": 0},
            "autosize": "none",
            "signals": [
                {"name": "cx", "update": "width / 2"},
                {"name": "cy", "update": "height / 2"},
                {
                "name": "gravityX",
                "value": 0.2
                },
                {
                "name": "gravityY",
                "value": 0.8
                }
            ],
            "data": [
                {
                "name": "table",
                "values": []
                }
            ],
            "scales": [
                {
                "name": "size",
                "domain": {"data": "table", "field": "amount"},
                "range": [100, 3000]
                },
                {
                "name": "color",
                "type": "ordinal",
                "domain": {"data": "table", "field": "category"},
                "range": {"scheme": "blues"}
                }
            ],
            "marks": [
                {
                "name": "nodes",
                "type": "symbol",
                "from": {"data": "table"},
                "encode": {
                    "enter": {
                        "fill": {"scale": "color", "field": "category"},
                        "xfocus": {"signal": "cx"},
                        "yfocus": {"signal": "cy"}
                    },
                    "update": {
                        "size": {"signal": "pow(2 * datum.amount, 2)", "scale": "size"},
                        "stroke": {"value": "white"},
                        "strokeWidth": {"value": 1},
                        // "strokeOpacity": {"value":0.1},
                        // "fillOpacity": {"field": "amount"},
                        "tooltip": {"signal": "datum"}
                    }
                },
                "transform": [
                    {
                    "type": "force",
                    "iterations": 100,
                    "static": false,
                    "forces": [
                        {
                        "force": "collide",
                        "iterations": 2,
                        "radius": {"expr": "sqrt(datum.size) / 1.8"}
                        },
                        {"force": "center", "x": {"signal": "cx"}, "y": {"signal": "cy"}},
                        {"force": "x", "x": "xfocus", "strength": {"signal": "gravityX"}},
                        {"force": "y", "y": "yfocus", "strength": {"signal": "gravityY"}}
                    ]
                    }
                ]
                },
                {
                "type": "text",
                "from": {"data": "nodes"},
                "encode": {
                    "enter": {
                        "dx":{"value":0},
                        "align": {"value": "center"},
                        "baseline": {"value": "middle"},
                        "fontSize": {"value": 12},
                        "fill": {"value": "black"},
                        "text": {"field": "datum.category"},
                        "limit": {"value": 80}
                    },
                    "update": {"x": {"field": "x"}, "y": {"field": "y"}}
                }
                }
            ]
        }
        var data = $.extend(true, {}, vegaConfig); //深拷贝

        data.data[0].values = vegaData;

        var view = new vega.View(vega.parse(data))
          .renderer("canvas")
          .initialize("#vegaView")
          .hover()           
          .run();

        this.getTooltip(view);

        let that = this;
        view.addEventListener('click', function(event, item) {
              let configData = null;
              if(item && item.text){
                  configData = item.datum.datum;
              }else if(item && item.datum){
                  configData = item.datum;
              }

              
              if(configData && configData?.tags["tech_dev"]){
                  that.$message.warning("建设中...");
                  return ;
              }
              if(configData){
                that.$message.warning("建设中...");
                //   that.appConf.conf = configData;
                //   that.useToolTitle = configData.category;
                //   that.useToolVisible = true;
                //   that.isLoadingDialog = true;
              }
          });
          
          
      },
      getTooltip(view){
            
            view.tooltip((handler, event, item, value)=>{
                //console.log(handler, event, item, value);
                // let el = document.getElementById('tip-'+item.index);
                let el = document.getElementById('tip-vega');
                if (!el) {
                el = document.createElement('div');
                // el.setAttribute('id', 'tip-'+item.index);
                el.setAttribute('id', 'tip-vega');
                el.classList.add('vg-tooltip');

                //const tooltipContainer = document.fullscreenElement ?? document.body;
                // document.appendChild(el);
                document.body.appendChild(el);
                }
                if (value == null || value === '') {
                //el.classList.remove('visible');
                el.hidden = true;
                return;
                }
                el.hidden = false;
                let configData = {};
                if(item && item.text){
                    configData = item.datum.datum;
                }else if(item && item.datum){
                    configData = item.datum;
                }
                let html = "";
                html += `<span>${configData.category}</span>`
                if(configData.desc != null && configData.desc != ""){
                    html += `</br><span>${configData.desc}</span>`
                }
                el.innerHTML = html;
                let st = document.body.scrollTop || document.documentElement.scrollTop;
                let sl = document.body.scrollLeft || document.documentElement.scrollLeft;
                let left = event.clientX;
                let top = event.clientY;

                el.style.left = (left+10) + sl + 'px';
                el.style.top = (top+20) + st + 'px';
            });
            view.runAsync();
        },
    },
    mounted() {
      this.getTableDatas();
      this.vegaInit();
    },
    computed: {},
    created() {
    }


}
</script>

<style lang="less" scoped>
#tip-vega {
    position: absolute;
    background-color: rgba(255, 255, 255, .5);
    border: 1px solid rgb(189, 186, 186);
    border-radius: 5px;
    padding: 5px 10px;
    font-size: 12px;
    text-align: left;
    max-width: 300px;
    min-width: 100px;
}
</style>

